import { GlobalState } from "./GlobalState";

export const $state = new GlobalState();
